/*
  번들에 실리는 설정값.

  ★ Vite 는 `VITE_` 접두사가 붙은 값만 번들에 넣는다. 바꿔 말하면 **`VITE_` 가 붙으면 전부 공개**다.
    v1 이 `NEXT_PUBLIC_SUPABASE_ANON_KEY` 를 브라우저에 실어 보내 DB 를 직접 열 수 있었던 사고가
    그래서 났다(V2.md 불변 규칙 1). front 가 같은 검사를 하고, 외부에 열리는 이 앱은 더 필요하다.
*/
const SECRET_PATTERNS = [
  /SUPABASE/i,
  /DATABASE/i,
  /SERVICE_ROLE/i,
  /SECRET/i,
  /PASSWORD/i,
  /ANTHROPIC/i,
  /_KEY$/i,
  /TOKEN$/i,
];

function assertNoSecrets(): void {
  const offenders = Object.keys(import.meta.env).filter(
    (key) => key.startsWith('VITE_') && SECRET_PATTERNS.some((pattern) => pattern.test(key)),
  );
  if (offenders.length === 0) return;

  const message = `번들에 비밀값처럼 보이는 환경변수가 실렸다: ${offenders.join(', ')}`;
  if (import.meta.env.DEV) throw new Error(message);
  // 운영에서 던지면 앱이 통째로 안 뜬다. 크게 남기고 계속 간다.
  console.error(message);
}

assertNoSecrets();

export const env = {
  /**
   * API 앞자리. 기본 `/api/external` — nginx 가 같은 오리진으로 프록시하므로 CORS 가 필요 없다.
   *
   * <b>`/api/v1` 을 여기 넣지 않는다.</b> 내부 API 는 이 앱의 토큰(`aud=external`)을 401 로 거절하고,
   * nginx 도 `external.*` 에서 그 경로를 프록시하지 않는다(DOC-82 §5-1).
   */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/external',
  buildNumber: import.meta.env.VITE_BUILD_NUMBER ?? 'dev',
  isDev: import.meta.env.DEV,

  /**
   * 개발용 응답을 쓸 것인가 — 화면을 먼저 만들고 서버를 뒤에 붙이는 동안.
   *
   * <p><b>`import.meta.env.DEV` 가 앞에 있는 것이 핵심이다.</b> 운영 빌드에서는 이 값이 상수
   * `false` 로 접히고, 그것을 보는 동적 {@code import()} 가지도 함께 떨어져 나간다.
   * 즉 <b>환경변수를 잘못 넣어도 운영에 목이 나갈 수 없다.</b>
   *
   * <p>기본 켜짐인 것은 backend 의 {@code app.auth.stub-login.enabled} 가 local 문서에서만
   * 켜지는 것과 같은 자리다 — 개발 중의 편의이지 운영의 선택지가 아니다.
   * 진짜 서버에 붙여 보려면 `vendor/.env.local` 에 `VITE_STUB_API=false`.
   */
  stubApi: import.meta.env.DEV && import.meta.env.VITE_STUB_API !== 'false',
} as const;
